module.exports = __webpack_public_path__ + "img/H1.fec46c1a.png";